'use strict';

var ContributingFBCsGridDirective = function ContributingFBCsGridDirective() {
  return {
    template: require('../templates/contributing-fbcs-grid.html'),
    restrict: 'E',
    controller: 'ContributingFBCsGridController',
    scope: {
      screenState: '='
    },
    link: function link($scope) {
      $scope.$on('fares-contributing-fbcs-grid:saveChanges', $scope.saveFares);
    }
  };
};
ContributingFBCsGridDirective.$inject = [];
module.exports = ContributingFBCsGridDirective;